module.exports = __webpack_public_path__ + "img/AKA 1982.341850b2.png";